import moment from "moment";

/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

export function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function base64toFile(base64, filename) {
  var arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

/**
 * 从新拼装地址
 * @param country
 * @param province
 * @param city
 * @param area
 */
export function getAddress(country, province, city, area) {
  const resutl = [];
  if (country) {
    resutl.push(country);
  }
  if (province) {
    resutl.push(province);
  }
  if (city) {
    resutl.push(city);
  }
  if (area) {
    resutl.push(area);
  }
  return resutl.join("|");
}

export function addChildNode(parentId, subNodes, treeOption) {
  for (let i = 0; i < treeOption.length; i++) {
    if (treeOption[i].value === parentId) {
      // 将子节点插入到父节点的children数组中
      treeOption[i].children = subNodes;
      return; // 找到后直接返回，避免重复插入（假设树中不会有重复的parentId和value）
    }
    // 如果当前节点有children，则递归查找（但在这个特定情况下，我们不需要递归，因为parentId是直接的）
    // 不过，为了通用性，这里还是保留递归的逻辑（虽然在这个例子中不会用到）
    if (treeOption[i].children) {
      addChildNode(parentId, subNodes, treeOption[i].children);
    }
  }
  // 注意：在这个特定例子中，我们不需要上面的递归调用，因为parentId直接指向了树的一层节点
  // 但如果你有一个更复杂的树结构，并且子节点可能需要插入到更深层次的节点中，那么递归调用就是必要的
}

/**
 * 比例转化
 * @param rate 要转换的值
 * @param type 是保存还是详情
 */
export function toFixedNumFun(rate, type) {
  if (!rate) {
    return 0;
  }
  let currentRate = rate;
  if (type === "save") {
    currentRate = (currentRate / 100).toFixed(4);
  } else if (type === "info") {
    currentRate = currentRate * 100;
  }
  return currentRate;
}

/**
 * copy
 * @param t 要复制的内容
 */
export function copyClick(t) {
  const textarea = document.createElement("textarea");
  textarea.value = t;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("Copy");
  document.body.removeChild(textarea);
  this.$message.success("复制成功");
  return true;
}

/**
 * 下载xlsx
 * @param blobData 下载的blob文件
 * @param title 文档的标题
 */
export function uploadXlsx(blobData, title) {
  if (!blobData) {
    return;
  }
  const url = window.URL.createObjectURL(blobData);
  let currentTitle = title;
  let currentDate = moment().format("YYYYMMDDHHmmss");

  const link = document.createElement("a");
  link.href = url;

  // 你可以设置下载的文件名，例如：
  link.setAttribute("download", currentTitle + currentDate + ".xlsx"); // 根据实际文件类型和需要设置正确的扩展名

  // 模拟点击下载
  document.body.appendChild(link);
  link.click();

  // 清理并释放掉ObjectURL
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
/**
 * 验证正负数
 * @param {Object} str
 */
export function isPositiveNegativeOrZero(str) {
  if(str){
    const currentStr = parseInt(str);
    return currentStr>0;
  }
  console.log("strstrstrstr",str);
  return str;
}

/**
 * 处理银行卡号
 * @param {Object} cardNumber
 */
export function processingBankNumber(cardNumber){
  if (!cardNumber || cardNumber.length <= 4) {
    return cardNumber;
  }
  return cardNumber.replace(/(.{4})/g, "$1 ");
}
